import React from "react";
import { ActionIcon } from '@mantine/core';
import { TimeInput } from '@mantine/dates';
import { IconClock } from '@tabler/icons-react';

const PickerTime = ({
    stateDate = "00:00",
    fnSetDate,
    stateLabel = '',
    stateDisabled = false,
    stateWithAsterisk = false,
    stateDescription = '',
    stateError = '',
    stateVariant = 'default', /* default | filled | unstyled */
    stateRadius = 'sm',
    stateSize = 'sm',
    stateSX = {},
    stateMT = '0',
    stateMB = '0'
}) => {

    const ref = React.useRef();

    return (
        <TimeInput
            label={stateLabel}
            value={stateDate}
            onChange={fnSetDate}
            disabled={stateDisabled}
            description={stateDescription}
            error={stateError}
            variant={stateVariant}
            radius={stateRadius}
            size={stateSize}
            withAsterisk={stateWithAsterisk}
            sx={stateSX}
            ref={ref}
            mt={stateMT}
            mb={stateMB}
            rightSection={
                <ActionIcon onClick={() => ref.current.showPicker()}>
                    <IconClock size="1.25rem" stroke={1.5} />
                </ActionIcon>
            }
        />
    )
}

export default PickerTime;